import { StrictMode, startTransition } from 'react';
import * as Sentry from '@sentry/react-router';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

async function initSentry() {
  if (!ENV.SENTRY_DSN) return;
  try {
    const { init } = await import('./utils/monitoring.client');
    init();
  } catch (error) {
    console.error('Failed to initialize monitoring:', error);
  }
}

async function enableMocking() {
  if (ENV.VITE_ENABLE_MOCKS !== 'true') return;

  const [{ worker }, { getActiveHandlers }] = await Promise.all([
    import('./mocks/browser'),
    import('./mocks/handlers'),
  ]);

  await worker.start({ onUnhandledRequest: 'bypass' });
  worker.use(...getActiveHandlers());
}

async function hydrate() {
  await Promise.all([initSentry(), enableMocking()]);

  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter onError={Sentry.sentryOnError} />
      </StrictMode>
    );
  });
}

hydrate();
